import { isoDate } from './dates';

type QueryValue = string | number | boolean | undefined | null;

/** Builds a URL, skipping params whose value is undefined, null, false or ''. */
export function buildUrl(
  base: string,
  params: Record<string, QueryValue>
): string {
  const url = new URL(base);
  for (const [key, value] of Object.entries(params)) {
    if (
      value === undefined ||
      value === null ||
      value === false ||
      value === ''
    )
      continue;
    url.searchParams.set(key, value === true ? '1' : String(value));
  }
  return url.toString();
}

/** Joins non-empty query parts with spaces. */
export function joinQuery(...parts: Array<string | undefined | false>): string {
  return parts.filter(Boolean).join(' ').trim();
}

/**
 * Local calendar date (YYYY-MM-DD) for `count` units before `now`. Local, not
 * UTC, so an evening search in the Americas doesn't jump to tomorrow's date;
 * month and year steps clamp to the month's last day (Mar 31 - 1m = Feb 28).
 */
export function dateBefore(
  unit: 'h' | 'd' | 'w' | 'm' | 'y',
  count: number,
  now = new Date()
): string {
  const d = new Date(now);
  if (unit === 'h') d.setHours(d.getHours() - count);
  if (unit === 'd') d.setDate(d.getDate() - count);
  if (unit === 'w') d.setDate(d.getDate() - 7 * count);
  if (unit === 'm' || unit === 'y') {
    const months = unit === 'm' ? count : 12 * count;
    const target = new Date(d.getFullYear(), d.getMonth() - months, 1);
    const last = new Date(
      target.getFullYear(),
      target.getMonth() + 1,
      0
    ).getDate();
    d.setFullYear(
      target.getFullYear(),
      target.getMonth(),
      Math.min(d.getDate(), last)
    );
  }
  return isoDate(d);
}
